import { ConfigService } from '@services/webFeeder/config.service';
import { Component, OnInit, Inject } from '@angular/core';
import { Constants } from '@utils/constants';
import { NotificationsService } from 'angular2-notifications';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { CustomWorkspaceModalComponent } from '@component/custom-workspace-modal/custom-workspace-modal.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-tools',
  templateUrl: './add-tools.component.html',
})
export class AddToolsComponent implements OnInit {

  value: any;
  filteredSearch = [];
  cardData = [];
  showOnlyMarketData: boolean;
  showSearch = false;
  listCard = [
    { title: 'Cotação', filter: false, list: [] },
    { title: 'Negociação', filter: false, list: [] },
  ];
  cardTitles = [
    { id: Constants.WINDOW_NAME_QUOTE_CHART, title: Constants.TITLE_CARD_QUOTE_CHART, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_BOOK, title: Constants.TITLE_CARD_BOOK, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_HIGH_LOW_DAY, title: Constants.TITLE_CARD_HIGH_LOW_DAY, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_TIMES_TRADES, title: Constants.TITLE_CARD_TIMES_TRADES, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_NEWS_WKS, title: Constants.TITLE_CARD_NEWS_WKS, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_WORK_SHEET, title: Constants.TITLE_CARD_WORKSHEET, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_ASSET_SUMMARY, title: Constants.TITLE_CARD_ASSET_SUMMARY, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_VOLUME_AT_PRICE, title: Constants.TITLE_CARD_VOLUME_AT_PRICE, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_ORDER_WKS, title: Constants.TITLE_CARD_ORDER_WKS, isCardMarketData: false },
    { id: Constants.WINDOW_NAME_POSITION_DAY, title: Constants.TITLE_CARD_POSITION_DAY, isCardMarketData: false },
    { id: Constants.WINDOW_NAME_BILLET_ROOT, title: Constants.TITLE_CARD_BILLET_ROOT, isCardMarketData: false },
    { id: Constants.WINDOW_NAME_POSITION_BALANCE, title: Constants.TITLE_CARD_POSITION_BALANCE, isCardMarketData: false }
  ];

  constructor(
    private notificationService: NotificationsService,
    private workspaceService: WorkspaceNewService,
    private _configService: ConfigService,
    public dialogRef: MatDialogRef<CustomWorkspaceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.showOnlyMarketData = this._configService.isLoginMarketData();
  }

  ngOnInit() {
    this.loadInitial();
  }


  loadInitial() {
    this.cardTitles.forEach(item => {
      if (item.isCardMarketData) {
        this.listCard[0].list.push(item);
      } else if (!this.showOnlyMarketData) {
        this.listCard[1].list.push(item);
      }
    });
    this.listCard.forEach(element => {
      if (element.list.length) {
        element.list.forEach(item => {
          this.cardData.push(item);
        });
      }
    });
    this.filterComponent();
  }

  filterComponent(event?) {
    this.showSearch = false;
    if (event && event.target.value) {
      this.showSearch = true;
      const value = event.target.value.toUpperCase();
      this.filteredSearch = this.cardData.filter(element => {
        const item = element.title.toUpperCase();
        return item.indexOf(value) > -1;
      });
    } else {
      this.filteredSearch = [...this.cardData];
    }

  }

  addItemWorkspace(item) {
    if (item) {
      this.workspaceService.addItemWorkspace(item, null);
    } else {
      this.notificationService.error('', 'Não foi possível adicionar a ferramenta no workspace atual');
      return;
    }
    this.dialogRef.close();
  }
}

